import React from 'react';
import Input from '@material-ui/core/Input';
import Box from '@material-ui/core/Box';
import {Link, useLocation} from 'react-router-dom';
import Button from '@material-ui/core/Button';

import {adminRoutes} from 'App/AppRouter/routes';
import {OnSearch} from './UsersListTypes';

interface UsersToolbarProps {
    name: string;
    onSearch: OnSearch;
}

export default function UsersToolbar(props: UsersToolbarProps) {
    const {
        name,
        onSearch,
    } = props;
    
    const {search} = useLocation();
    const url = `${adminRoutes.addUser}${search}`;
    
    return (
        <Box className="toolbar">
            <Input
                className="toolbar__search"
                autoComplete="off"
                id="qc-filter__input"
                value={name}
                placeholder="Search"
                onChange={onSearch}
            />
            <Link
                className="toolbar__button-link"
                to={url}
            >
                <Button
                    className="toolbar__button"
                    variant="contained"
                >
                    ADD USER
                </Button>
            </Link>
        </Box>
    );
}
